import { CSSProperties } from "react";
import { Skeleton } from "@src/lib/ui/Skeleton";
import { LEADING_ROW_GUTTER } from "@src/lib/ui/Table";

const PADDING_LEFT = 8;

type Column = {
  width?: number;
  minWidth?: number;
  flex?: CSSProperties["flex"];
};

type TableSkeletonProps = {
  columns: Column[];
  rows?: number;
  rowHeight?: number;
  showOverflowColumn?: boolean;
  showCheckboxColumn?: boolean;
  checkboxColumnWidth?: number;
};

function TableSkeleton({
  columns,
  rows = 3,
  rowHeight = 42,
  showOverflowColumn,
  showCheckboxColumn,
  checkboxColumnWidth = 48,
}: TableSkeletonProps): React.ReactElement {
  return (
    <>
      {Array.from({ length: rows }, (_, i) => (
        <div
          key={i}
          className="flex flex-row self-stretch border-b border-gray-2"
          style={{ minHeight: rowHeight }}
        >
          {showCheckboxColumn ? (
            <div
              className="relative flex shrink-0 items-center justify-center self-stretch"
              style={{
                width: checkboxColumnWidth + PADDING_LEFT,
                minWidth: checkboxColumnWidth + PADDING_LEFT,
              }}
            >
              <Skeleton
                className="h-4"
                style={{ width: checkboxColumnWidth / 2 }}
              />
            </div>
          ) : (
            <div
              aria-hidden="true"
              className="shrink-0 self-stretch"
              style={{ width: LEADING_ROW_GUTTER }}
            />
          )}
          {columns.map((col, j) => (
            <div
              key={j}
              className="relative flex items-center self-stretch"
              style={{
                flex: col.flex ?? 1,
                width: col.width ? col.width + PADDING_LEFT : undefined,
                minWidth: col.minWidth
                  ? col.minWidth + PADDING_LEFT
                  : PADDING_LEFT,
                maxWidth: col.width ? col.width + PADDING_LEFT : undefined,
                paddingLeft: PADDING_LEFT,
              }}
            >
              <Skeleton className="h-4 w-3/4" />
            </div>
          ))}
          {showOverflowColumn && (
            <div
              className="relative flex items-center self-stretch"
              style={{
                width: 34 + PADDING_LEFT,
                minWidth: 34 + PADDING_LEFT,
                maxWidth: 34 + PADDING_LEFT,
                paddingLeft: PADDING_LEFT,
              }}
            >
              <Skeleton className="h-4 w-4" />
            </div>
          )}
        </div>
      ))}
    </>
  );
}

export { TableSkeleton };
